import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { TablePagination } from "@mui/material";
import { useHistory, Link } from "react-router-dom";
import Button from "../Button/Button";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: "bold",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function ActiveCampaign({ campaign, searchKey }) {
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const history = useHistory();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const route = (id) => {
    history.push({
      pathname: `/compaigndetail/${id}`,
      state: { isAdmin: true },
    });
  };
  React.useEffect(() => {
    setRows(campaign);
  }, [campaign]);

  const filterArray = () =>
    rows?.filter((val) => {
      if (searchKey === "") {
        return val;
      } else if (
        Object.values(val)
          ?.join(" ")
          ?.toLowerCase()
          ?.includes(searchKey?.toLowerCase())
      ) {
        return val;
      }
    });

  function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    url += "?" + new Date().getTime();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  const download = async (
    urlfront,
    urlBack,
    shirtDesignFront,
    shirtDesignBack
  ) => {
    const img = [urlfront, urlBack, shirtDesignFront, shirtDesignBack];
    for (let i = 0; i < img.length; i++) {
      await toDataURL(img[i], async function (myBase64) {
        if (myBase64 !== "data:") {
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          );
          let aEl = document.createElement("a");
          aEl.href = myBase64;
          aEl.download = `img.png`;
          document.body.appendChild(aEl);
          aEl.click();
          document.body.removeChild(aEl);
        }
      });
    }
  };

  const data = filterArray().sort(function compare(a, b) {
    var dateA = new Date(a.createdAt);
    var dateB = new Date(b.createdAt);
    return dateB - dateA;
  });

  return (
    <>
      {data?.length ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Product</StyledTableCell>
                <StyledTableCell>Real Price</StyledTableCell>
                <StyledTableCell>Selling Price</StyledTableCell>
                <StyledTableCell>Days</StyledTableCell>
                <StyledTableCell>Created At</StyledTableCell>
                <StyledTableCell align="right">Download Images</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length ? (
                data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, ind) => (
                    <StyledTableRow
                      key={ind + page * rowsPerPage}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        onClick={() => route(row.id)}
                      >
                        <img src={row?.designShirt} alt="shirt" width={100} />
                        <Typography
                          component="span"
                          sx={{
                            textTransform: "capitalize",
                            fontWeight: "bold",
                          }}
                        >
                          {row.shirtName ? row.shirtName : "-"}
                        </Typography>
                      </TableCell>
                      <StyledTableCell
                        sx={{ textTransform: "capitalize" }}
                        onClick={() => route(row.id)}
                      >
                        {row.realprice ? row.realprice : "-"}
                      </StyledTableCell>
                      <StyledTableCell onClick={() => route(row.id)}>
                        {row.sellingPrice ? row.sellingPrice : "-"}
                      </StyledTableCell>
                      <StyledTableCell onClick={() => route(row.id)}>
                        {row.days ? row.days : "-"}
                      </StyledTableCell>
                      <StyledTableCell onClick={() => route(row.id)}>
                        {row?.createdAt
                          ? new Date(row?.createdAt).toLocaleDateString()
                          : "-"}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Button
                          text="Download"
                          onClick={() =>
                            download(
                              row?.designShirt,
                              row?.designShirtBack,
                              row?.shirtDesignFront,
                              row?.shirtDesignBack
                            )
                          }
                        ></Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
              ) : (
                <Typography
                  sx={{ position: "absolute", top: "50%", left: "50%" }}
                >
                  No data found
                </Typography>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Typography component="h1" variant="h6">
            No Data Found
          </Typography>
        </Box>
      )}
      <TablePagination
        component="div"
        count={filterArray()?.length}
        onPageChange={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={false}
      />
    </>
  );
}
